import React from 'react';
import './index.scss';
import Breadcrumb from '../../DrugDetails/Breadcrumb';

const ConditionTabs = ({
  breadcrumb,
  h2Title,
  slug = '',
  slugType,
  linkedConditionPages = []
}) => {
  const url = slug;
  const typeAndURL = {
    symptoms: { url: 'conditions-symptoms', title: 'Symptoms Directory' },
    causes: { url: 'conditions-causes', title: 'Causes Directory' },
    treatments: { url: 'conditions-treatments', title: 'Treatments Directory' }
  };

  const routeUrlByType = type => {
    return typeAndURL[type]?.url;
  };

  const items = [
    { to: '/', label: 'Home' },
    {
      to: `/${routeUrlByType(slugType)}`,
      label: typeAndURL[slugType]?.title
    }
  ];

  return (
    <div className="subHeaderTabs">
      <div className="subHeaderContainer">
        <Breadcrumb items={items}>
          {items.map(({ to, label }) => (
            <a key={label} href={to}>
              {label}
            </a>
          ))}
          {breadcrumb && <span>{breadcrumb}</span>}
        </Breadcrumb>
        <h2>{h2Title && h2Title}</h2>
        <div className="tabsList">
          <ul>
            {linkedConditionPages?.map(({ slug, title }) => {
              return (
                <li className={slug === url ? 'current' : ''} key={title}>
                  <a href={`/conditions/${slug}`}>{title}</a>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ConditionTabs;
